import {
  View,
  Text,
  ActivityIndicator,
  TextInput
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import Card from '../../shared/card/Card'
import { Formik } from 'formik'
import CustomButton from '../../shared/button/Button'
import { globalStyles } from '../../../static/styles/global'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import { usePersonalStore } from '../../../stores/personalInfo'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import Toast from 'react-native-toast-message'
import * as yup from 'yup'
import { mapSelectValue } from '../../../utils'
const RiInformationForm = ({ navigation, route }: any) => {
    const { params } = route
    const {
        mostRecentUserOnBoardings: userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey
    } = params

    const { loading, postrionline, } = useFormsStore()
    const initializestore = useInitializeStore()
    const personalstore = usePersonalStore()

    const intialValues = {
        noofallowances: '',
        additionalWithholding: '',
        exemptionIndicator: '',
        martialStatus: ""
    }

    const paschema = yup.object({
        noofallowances: yup.string().required('No of allowances is a required field'),
        additionalWithholding: yup.string().nullable(),
        exemptionIndicator: yup
            .string()
            .transform((value) => (value ? value.toUpperCase() : value))
            .oneOf(["EXEMPT", "EXEMPT-MS"], 'Must be either "EXEMPT" or "EXEMPT-MS"')
            .nullable(),
    })

    const options1 = [
        { key: 1, value: 'Single' },
        { key: 2, value: 'Married' },

    ]


    return (
        <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'RI Withholding Taxation'}
                    />
                </View>
            </View>
            <View style={globalStyles.containerOverlap}>
                <Formik
                    initialValues={{ ...intialValues }}
                    validationSchema={paschema}
                    onSubmit={async (values, actions) => {
                        const data = {
                            essUserOnBoardingFormKey:
                                essUserOnBoardingFormKey,
                            essObKey: essUserOnBoardingKey,
                            completeOnline: mode === 'upload' ? false : true,
                            essUserKey:
                                initializestore.initializeData.userkey,
                            entityId: personalstore.personalData?.entityId,
                            noOfAllowances: values?.noofallowances ? values?.noofallowances : null,
                            additionalWithholding: values?.additionalWithholding ? values?.additionalWithholding : null,
                            exemptionIndicator: values?.exemptionIndicator,
                            maritalStatus: values?.martialStatus
                        }

                        const response = await postrionline(data)
                        if (response?.success) {
                            if (mode === 'online') {
                                navigation.navigate('RiInformationOnline', {
                                    userId,
                                    mode,
                                    essUserOnBoardingKey,
                                    essUserOnBoardingFormKey,
                                    values
                                })
                            } else {
                                await Toast.show({
                                    type: 'success',
                                    position: 'bottom',
                                    text1: response?.message,
                                    visibilityTime: 3000,
                                    autoHide: true,
                                    topOffset: 60,
                                    onHide: () => {
                                        navigation.replace('OnboardingForms')
                                    }
                                })
                            }
                        } else {
                            await Toast.show({
                                type: 'error',
                                position: 'bottom',
                                text1: response?.message,
                                visibilityTime: 3000,
                                autoHide: true,
                                topOffset: 60
                            })
                        }
                    }}
                >
                    {(props) => (
                        <>
                            <Card>

                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Martial status *'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <SelectKeyValue
                                            title="Martial status"
                                            options={options1}
                                            selectedOption={mapSelectValue(
                                                options1,
                                                props.values.martialStatus
                                            )}
                                            onSelect={(option: any) => {
                                                if (option == 1) {
                                                    props.setFieldValue('martialStatus', 'S')
                                                } else {
                                                    props.setFieldValue('martialStatus', 'M')

                                                }

                                            }}
                                            textColor="primary"
                                        />
                                        {props.touched.martialStatus &&
                                            props.errors.martialStatus && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.martialStatus}
                                                </Text>
                                            )}
                                    </View>
                                </View>
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Enter the number of allowances from line 1E *'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.noofallowances}
                                            keyboardType="numeric"
                                            onChangeText={(text) => {
                                                if (text === '' || /^\d+$/.test(text)) {
                                                    props.handleChange('noofallowances')(text)
                                                }
                                            }}
                                        />
                                        {props.touched.noofallowances &&
                                            props.errors.noofallowances && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.noofallowances}
                                                </Text>
                                            )}
                                    </View>
                                </View>


                                {!(props.values.exemptionIndicator?.toUpperCase() === 'EXEMPT' || props.values.exemptionIndicator?.toUpperCase() === 'EXEMPT-MS') && (
                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ justifyContent: 'center', width: '50%' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {'Enter any additional dollar amount which you would like withheld from your pay'}
                                            </Text>
                                        </View>
                                        <View style={{ width: '28%', overflow: 'hidden' }}>
                                            <TextInput
                                                style={[globalStyles.input, globalStyles.inputLight]}
                                                value={props.values.additionalWithholding}
                                                keyboardType="numeric"
                                                onChangeText={(text) => {
                                                    if (text === '' || /^\d+$/.test(text)) {
                                                        props.handleChange('additionalWithholding')(text)
                                                    }
                                                }}
                                            />
                                            {props.touched.additionalWithholding &&
                                                props.errors.additionalWithholding && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.additionalWithholding}
                                                    </Text>
                                                )}
                                        </View>
                                    </View>
                                )}




                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '50%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'If you meet the conditions above, write “EXEMPT” or “EXEMPT-MS” whichever applies'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.exemptionIndicator}
                                            onChangeText={(text) => {
                                                props.handleChange('exemptionIndicator')(text)
                                                if (text?.toUpperCase() === 'EXEMPT' || text?.toUpperCase() === 'EXEMPT-MS') {
                                                    props.setFieldValue('additionalWithholding', '')
                                                }
                                            }}
                                        />
                                        {props.touched.exemptionIndicator && props.errors.exemptionIndicator && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.exemptionIndicator}
                                            </Text>
                                        )}
                                    </View>
                                </View>



                                {loading ? (
                                    <ActivityIndicator />
                                ) : (
                                    <View style={{ margin: 10 }}>
                                        <CustomButton
                                            text={mode === 'upload' ? 'Submit Information' : 'Next'}
                                            onPress={props.handleSubmit}
                                        />
                                    </View>
                                )}
                            </Card>
                        </>
                    )}
                </Formik>
            </View>

        </KeyboardAwareScrollView>
    )
}

export default RiInformationForm
